export const GiftingRedirectModalContent = {
  mixed: {
    title: `We are not able to process gifts in this experience`,
    bodyText: `You listed the following transfers as gifts:`,
    body2: `If you continue, we'll remove any gifts from this transfer, and you can complete them later using our `,
    linkText: `gifting experience.`,
    primaryButton: `Continue and remove`,
  },
  giftsOnly: {
    title: `We can't process your gift using this experience`,
    bodyText: `This experience can only be used to make non-gift internal transfers. If you'd like to send a gift, please continue to gifting or close this message to change your selections.`,
    primaryButton: `Continue to gifting`,
  },
  closeButton: `Close`,
};
